.headerRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 4px 4px;
  gap: 8px;
}

.headerTitle {
  font-weight: 600;
  font-size: var(--tuna-typography-fontSize-md);
  color: var(--tuna-palette-text-secondary);
}

.newButton {
  /* compact, primary-tinted; relies on ui-lib Button defaults */
  white-space: nowrap;
}

.row {
  display: block;
  width: 100%;
  text-align: left;
  background: transparent;
  border: 1px solid var(--tuna-palette-divider);
  border-radius: var(--tuna-shape-radius-md);
  padding: 8px 10px;
  margin-bottom: 6px;
  cursor: pointer;
  color: var(--tuna-palette-text-primary);
  font-size: var(--tuna-typography-fontSize-md);
  line-height: 1.3;
  transition:
    background-color 0.12s ease,
    border-color 0.12s ease;
}

.rowMain {
  display: block;
}

.rowAnchor {
  display: block;
  margin-top: 4px;
  padding-left: 2px;
  font-size: var(--tuna-typography-fontSize-xs);
  font-style: italic;
  color: var(--tuna-palette-text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.expandedAnchor {
  padding: 4px 12px 0;
  font-size: var(--tuna-typography-fontSize-xs);
  font-style: italic;
  color: var(--tuna-palette-text-secondary);
  border-bottom: 1px solid var(--tuna-palette-divider);
  padding-bottom: 6px;
}

.row:hover {
  background-color: var(--tuna-palette-action-hover);
  border-color: var(--tuna-palette-divider);
}

.row:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: 1px;
}

.rowDate {
  font-weight: 600;
  color: var(--tuna-palette-text-secondary);
  margin-right: 6px;
}

.rowPreview {
  color: var(--tuna-palette-text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.rowPreviewEmpty {
  color: var(--tuna-palette-text-secondary);
  font-style: italic;
}

.expandedCard {
  border: 1px solid var(--tuna-palette-primary-main);
  /* The 3px solid selection-token left edge is the row half of the synchronous
   * pairing — the matching block in the editor wears the same accent via
   * `data-anchored-active`. Override the generic 1px on the left only. */
  border-left-width: 3px;
  border-left-color: var(--tuna-palette-selection);
  border-radius: var(--tuna-shape-radius-md);
  margin-bottom: 8px;
  background-color: var(--tuna-palette-background-paper);
  overflow: hidden;
}

/* Visually hidden caption for screen readers — keyed by `aria-describedby`
 * on the row button. Standard sr-only pattern (clip out, keep in DOM). */
.srOnly {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.expandedHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 8px 6px 12px;
  border-bottom: 1px solid var(--tuna-palette-divider);
  background-color: var(--tuna-palette-action-hover);
}

.expandedDate {
  font-weight: 600;
  font-size: var(--tuna-typography-fontSize-md);
  color: var(--tuna-palette-text-secondary);
}

.expandedEditor {
  padding: 8px 12px;
}

.emptyStateBox {
  padding: 12px 8px;
  margin-bottom: 8px;
}

.emptyStateText {
  display: block;
  margin-bottom: 12px;
  color: var(--tuna-palette-text-secondary);
  font-size: var(--tuna-typography-fontSize-md);
  line-height: 1.4;
}

/* Notes and documents split the available height. Each section is a flex column
 * with a pinned header and an independently scrollable list — so a long notes
 * list never pushes documents off-screen, and vice versa.
 *
 * `flex-basis: auto` (not 0) is deliberate: this panel mounts in two places —
 * the editor right-rail (definite height) and the playlist performance sidebar,
 * whose ancestor flex chain runs through several `overflow: auto` containers and
 * is not guaranteed to resolve to a definite height. With `flex: 1 1 0`, an
 * indefinite parent leaves no free space to distribute, so both sections
 * collapse to header height and the note content disappears (see #1617). With
 * `flex-basis: auto` the sections fall back to their content height when the
 * parent is indefinite, and still grow to split the space when it is definite.
 *
 * `min-height: 0` is the standard flexbox-shrink fix: it lets a section shrink
 * below its content's intrinsic size so the inner `.sectionScroll` can scroll
 * when the parent height *is* bounded.
 */
.section {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
}

.section + .section {
  border-top: 1px solid var(--tuna-palette-divider);
}

.sectionScroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}
